import { render } from "./Fees_Payment.vue?vue&type=template&id=ab194878&scoped=true"
import script from "./Fees_Payment.vue?vue&type=script&lang=js"
export * from "./Fees_Payment.vue?vue&type=script&lang=js"

import "./Fees_Payment.vue?vue&type=style&index=0&id=ab194878&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab194878"]])

export default __exports__